import { ISanPhamPhamVi } from "../../model/respone/san-pham/ISanPhamPhamVi"
import { apiClient } from "../apiClient"

export const SAN_PHAM_PHAM_VI_API_RESOURCE = "san-pham-pham-vi"
export const sanPhamPhamViApi = {
    GetAll: () => apiClient.get(`${SAN_PHAM_PHAM_VI_API_RESOURCE}`),
    GetById: (id: number) => apiClient.get(`${SAN_PHAM_PHAM_VI_API_RESOURCE}/${id}`),
    Insert: (payload: ISanPhamPhamVi) => apiClient.post(`${SAN_PHAM_PHAM_VI_API_RESOURCE}`, payload),
    Update: (payload: ISanPhamPhamVi) => apiClient.put(`${SAN_PHAM_PHAM_VI_API_RESOURCE}`, payload),
    Delete: (id: number) => apiClient.delete(`${SAN_PHAM_PHAM_VI_API_RESOURCE}/${id}`),
}
